import React, { useContext } from 'react';
import { Column, LocaleContext, Row } from 'shared';
import { CertificateType } from 'store/api/types';

import { AddCertificateField } from './addCertificateField/AddCertificateField';
import { CertificationsLabel } from './Certifications.styles';
import { CertificationsProps } from './Certifications.types';

export const Certifications = ({ setQwacFileName, setQsealcFileName }: CertificationsProps) => {
  const localeContext = useContext(LocaleContext);

  return (
    <Row flexDirection={['column', 'row']} alignItems={['flex-start']} mt="2rem">
      <Column size={[12, 4]}>
        <CertificationsLabel style={{ lineHeight: '2rem' }}>
          {localeContext.formatMessage({ id: 'FORM.CERTIFICATIONS' })}
        </CertificationsLabel>
      </Column>
      <Column size={[12, 8]}>
        <AddCertificateField certificateType={CertificateType.QWAC} setFileName={setQwacFileName} />
        <AddCertificateField certificateType={CertificateType.QSEALC} setFileName={setQsealcFileName} />
      </Column>
    </Row>
  );
};
